export interface IGrossCommissionEarnedConfig{
  commissionReceivedFrom: number;
  commissionReceivedTo: number;
  fixedEvaluationPeriod: boolean;
  accumulatedPeriod: number;
  resetAccumulatedPeriod: number;
  excludeOwnTransaction: boolean;
  isActive:boolean;
}
